// ================================================================
// Weekday Name Constants
// Single source of truth for weekday-name lookup arrays.
// 0-indexed and Sunday-first (0 = Sunday … 6 = Saturday) to match
// JavaScript's Date.getDay() and the day_of_week values stored in
// our schedule rows. Plain TS — no React / client / server-only
// imports — so both client components and server code (API routes,
// services) can import it.
// ================================================================

/**
 * Full weekday names, indexed by Date.getDay() (0 = Sunday).
 * Example: WEEKDAY_NAMES[new Date().getDay()] → "Monday"
 */
export const WEEKDAY_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const;

/**
 * Abbreviated (3-letter) weekday names, indexed by Date.getDay() (0 = Sunday).
 * Example: WEEKDAY_NAMES_SHORT[new Date().getDay()] → "Mon"
 */
export const WEEKDAY_NAMES_SHORT = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
] as const;

/**
 * Pluralized weekday names (for "meets on Mondays"-style copy),
 * indexed by Date.getDay() (0 = Sunday).
 * Example: WEEKDAY_NAMES_PLURAL[new Date().getDay()] → "Mondays"
 */
export const WEEKDAY_NAMES_PLURAL = [
  'Sundays',
  'Mondays',
  'Tuesdays',
  'Wednesdays',
  'Thursdays',
  'Fridays',
  'Saturdays',
] as const;
